import { FETCH_SETTING } from "../constants/setting";

export function fetchSetting() {
  return {
    type: FETCH_SETTING,
    api: true,
    payload: {
      method: "GET",
      url: "/settings-sapi",
    },
  };
}
